<template>
 <div class="index">
   <van-button type="primary" style="margin-bottom: 20px;border-radius: 5px;height: 60px;font-size: 20px" block @click="openXueyuan(0)">购买</van-button>
   <van-button type="info"  block style="border-radius: 5px;height: 60px;font-size: 20px" @click="openXueyuan(1)">我的订单</van-button>
 </div>
</template>

<script>
export default {
  name: "checkType",
  methods:{
    openXueyuan(type){
      if (type == 0){
        this.$router.push('/toubaoManager');
      }else {
        this.$router.push('/myOrders');
      }

    }
  }
}
</script>

<style scoped>
.index{
  padding-top: 40%;
  margin-left: 20%;
  width: 60%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// checkType.vue?8cfffa66